// removed by extract-text-webpack-plugin
module.exports = {"wrapper-pull-right":"wrapper-pull-right__2a9Ej","table-pager":"table-pager__n8KiT","pager-button":"pager-button__6r8qe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TablePagerTDM/styles.scss
// module id = 2156
// module chunks = 1